<template>
    <div class="content">
      <router-view>

      </router-view>
    </div>
</template>

<script>

export default {
  name: "Content",
};
</script>

<style>
.content {
  grid-area: content;
  padding: 2px 20px 10px 20px;
  margin-top: -15px;
}
</style>